import React from "react";

const DEFAULT_PILL_CLASS = "bg-red-100 text-red-800";

/**
 * Active filters as removable pills.
 * @param {string[]} activeKeys - keys that have active values
 * @param {Object} filters - key -> value
 * @param {function} getLabel - (key, value) => display string
 * @param {function} onRemove - (key) => {}
 * @param {string} [label] - e.g. "Active Filters:"
 * @param {function} [getPillClassName] - (key) => Tailwind classes for pill (e.g. "bg-red-100 text-red-800")
 */
const ActiveFilterPills = ({
  activeKeys,
  filters,
  getLabel,
  onRemove,
  label = "Active Filters:",
  getPillClassName,
}) => {
  if (!activeKeys?.length) return null;

  return (
    <div className="mb-3 flex flex-wrap gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
      <span className="text-xs font-semibold text-gray-700 self-center">
        {label}
      </span>
      {activeKeys.map((key) => (
        <span
          key={key}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${getPillClassName ? getPillClassName(key) : DEFAULT_PILL_CLASS}`}>
          {key.replace(/_/g, " ")}: {getLabel(key, filters[key])}
          <button
            type="button"
            onClick={() => onRemove(key)}
            className="hover:bg-black/10 rounded-full p-0.5 transition-colors"
            aria-label={`Remove ${key} filter`}>
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </span>
      ))}
    </div>
  );
};

export default ActiveFilterPills;
